<script lang="ts" setup>
import type { SizeVariants } from '~kui/types/kui';

import KUICoreCarouselDot from '~kui/components/KUI/Core/Carousel/KUICoreCarouselDot.vue';
import { useI18n } from 'vue-i18n';

interface Props {
  total: number;
  activeIndex: number;
  size?: Extract<SizeVariants, 'sm' | 'md' | 'lg'>;
  variant?: 'default' | 'pill';
}

withDefaults(defineProps<Props>(), {
  size: 'md',
  variant: 'default',
});

const emit = defineEmits<{
  select: [index: number, userInitiated: boolean];
}>();

const { t } = useI18n();

const onDotClick = (index: number) => {
  emit('select', index, true);
};
</script>

<template>
  <div
    class="flex items-center justify-center gap-1.5"
    role="group"
    :aria-label="t('unified.common.carousel.navigation')"
    @keydown.right.prevent="onDotClick(Math.min(activeIndex + 1, total - 1))"
    @keydown.left.prevent="onDotClick(Math.max(activeIndex - 1, 0))"
  >
    <KUICoreCarouselDot
      v-for="index in total"
      :key="`carousel-dot-${index}`"
      :active="activeIndex === index - 1"
      :size="size"
      :variant="variant"
      :aria-label="t('unified.common.carousel.slideOf', { current: index, total })"
      @click="onDotClick(index - 1)"
    />
  </div>
</template>
